export * from './credenciado-formas-pgto-form/credenciado-formas-pgto-form.component';
export * from './galeria-get/galeria-get.component';
export * from './horario2str/horario2str.component';
export * from './operador-tipo-form/operador-tipo-form.component';
export * from './setores-entrega/setores-entrega.component';
